import styled from 'styled-components'

export const PageTitle = styled.h1`
  text-align: left;
  font-size: 1.5rem;
  display: flex;
  position: relative;
`
